function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const HandshakeIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 22c1.3 0 1.3-2 0-2s-1.3 2 0 2zm23-.9c-1.2-1.6-2.4-3.2-3.8-4.7l-2 2.2c-1.7 2-4.8 1.9-6.5-.1-1.2-1.4-1.2-3.5 0-4.9l2.8-3.2c-1-.5-2.1-.3-3.2-.3-.9 0-1.8.4-2.5 1l-2.5 2.5H6V22c.7 0 1.3-.1 1.9.4l4.6 4.6c1 .9 2.2 1.7 3.5 1.7.7 0 1.5-.2 2-.7 1.2.4 2.5-.2 2.9-1.5.8.1 1.4-.2 2-.7.4-.3.8-1 .8-1.5.1.1.5.2.7.2 1.8 0 2.8-1.9 1.6-3.4zm2.5.9H30v-8h-1.5L26 11.2c-.7-.8-1.6-1.2-2.6-1.2h-2.6c-.9 0-1.7.4-2.3 1l-3.3 3.8c-.6.7-.6 1.7 0 2.3.9 1.1 2.5 1.1 3.5 0l3-3.4c.7-.8 2 0 1.7 1 .6.7 1.2 1.4 1.8 2 .8 1 1.5 2 2.3 3 .5.7.9 1.5 1 2.3zm4.5 0c1.3 0 1.3-2 0-2s-1.3 2 0 2zm3-9v10c0 .5-.5 1-1 1h-6.8c-.6 1.4-1.8 2.3-3.2 2.5-.7 1-1.7 1.7-2.9 2-.9 1.1-2.2 1.8-3.6 1.7-2.6 1.5-5.5.2-7.4-1.7L6.6 24H1c-.5 0-1-.5-1-1V12.5c0-.5.5-1 1-1h6.6c1.8-1.8 3-3.5 5.8-3.5h1.8c1 0 2 .3 2.8.9.8-.6 1.8-.9 2.8-.9h2.6c3 0 4.2 1.9 6 4H35c.5 0 1 .5 1 1z"
  }));
};
export default HandshakeIcon;